import axios from "axios";

export const state = {
    reportpurchasesbysupplier: [],
};

export const getters = {
    reportpurchasesbysupplier: state => state.reportpurchasesbysupplier,
};

export const mutations = {
    setReportPurchasesbySupplier(reportpurchasesbysupplier, newValue) { state.reportpurchasesbysupplier = newValue},
};

export const actions = {
    fetchReportPurchasesbySupplier({ commit }) {
        axios.get('/reportpurchasesbysupplier').then(res => {
            commit('setReportPurchasesbySupplier', res.data.purchases)
        })
    },
    filterReportPurchasesbySupplier({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportpurchasesbysupplier";
        axios.post(url, formData).then((response) => {
            commit('setReportPurchasesbySupplier', response.data.purchases)
        })
    },
};
